import React, {  useCallback } from "react";
import { Form } from "react-bootstrap";

export default function TypeInput({ type, setType, tabIndex, typeValidationError = null, typeIsSetByUser = false, setTypeIsSetByUser, ...props } : 
    { 
        type: string, 
        setType: (type: string) => void, 
        tabIndex: number, 
        typeValidationError?: string | null, 
        typeIsSetByUser?: boolean, 
        setTypeIsSetByUser?: (typeIsSetByUser: boolean) => void }) 
    {
    
        const handleChange = useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
            setType(event.target.value);

            if (setTypeIsSetByUser) {
                setTypeIsSetByUser(false);
            }

        }, [setType, setTypeIsSetByUser]);

        return (
            <Form.Group className="form-group template-type required">
                <Form.Label className="form-label" htmlFor="template-type-select">Type</Form.Label>
                <Form.Select 
                    className="form-select" 
                    id="template-type-select" 
                    tabIndex={tabIndex} 
                    required 
                    value={type||"none"} 
                    onChange={handleChange}
                    isInvalid={typeValidationError !== null && typeIsSetByUser}
                >
                    <option value="none" disabled>Sélectionner un Type</option>
                    <option value="cgv">Conditions générales de ventes</option>                
                    <option value="gc">Garanties commerciales</option>
                    <option value="cgvgc">Conditions générales de ventes + Garanties commerciales</option>
                    <option value="not_set">Autres</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">{typeValidationError}</Form.Control.Feedback>
            </Form.Group>
        );
    }